import { QueryList } from '@angular/core';
import * as sortBy from 'lodash/sortBy';
import { ChangeType, TerminalProcedure, TerminalProcedureBatchFormat, TerminalProcedureCycle, TerminalProcedurePack } from '../models/terminal-procedure.model';
import { ProcedureComponent } from '../procedure/procedure.component';
import { AirportService, MAX_PROC_BATCH_LIMIT } from '../airport.service';
/**
 * Placeholder message to show when no terminal procedures are available yet.
 */
var NO_PROCS_AVAILABLE = 'Terminal procedures are not yet available for the selected data cycle. Please check back later.';
/**
 * Placeholder message to show when no terminal procedures have changed in the selected data cycle.
 */
var NO_PROCS_CHANGED = 'No terminal procedures have been changed in the selected data cycle.';
/**
 * Placeholder message to show when no terminal procedures have been deleted in the selected data cycle.
 */
var NO_PROCS_DELETED = 'No terminal procedures have been deleted in the selected data cycle.';
var ProcedureListingComponent = /** @class */ (function () {
    function ProcedureListingComponent(_airportService) {
        this._airportService = _airportService;
        this.TerminalProcedureCycle = TerminalProcedureCycle;
        this.MAX_PROCEDURES = MAX_PROC_BATCH_LIMIT;
        this.TerminalProcedureBatchFormat = TerminalProcedureBatchFormat;
        this._hasProcs = false;
        this._cycle = TerminalProcedureCycle.Current;
        this._changedOnly = false;
        this._hideDeleted = false;
        this._allProcedures = [];
        this._changedProcedures = [];
        this._deletedProcedures = [];
        this._effDateFrom = null;
        this._effDateTo = null;
    }
    Object.defineProperty(ProcedureListingComponent.prototype, "hasProcs", {
        get: function () {
            return this._hasProcs;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProcedureListingComponent.prototype, "procedurePack", {
        get: function () {
            return this._procedurePack;
        },
        set: function (value) {
            this._procedurePack = value;
            this._hasProcs = value.current.procedures.length > 0
                || (value.next && value.next.procedures.length > 0);
            this._resetSettings();
            this._updateProcedures();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProcedureListingComponent.prototype, "cycle", {
        get: function () {
            return this._cycle;
        },
        set: function (value) {
            this._cycle = value;
            this._changedOnly = false;
            this._hideDeleted = false;
            this._updateProcedures();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProcedureListingComponent.prototype, "effDateFrom", {
        get: function () {
            return this._effDateFrom;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProcedureListingComponent.prototype, "effDateTo", {
        get: function () {
            return this._effDateTo;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProcedureListingComponent.prototype, "changedOnly", {
        get: function () {
            return this._changedOnly;
        },
        set: function (value) {
            this._changedOnly = value;
            this._updateProcedures();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProcedureListingComponent.prototype, "hideDeleted", {
        get: function () {
            return this._hideDeleted;
        },
        set: function (value) {
            this._hideDeleted = value;
            this._updateProcedures();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProcedureListingComponent.prototype, "allProcedures", {
        get: function () {
            return this._allProcedures;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProcedureListingComponent.prototype, "procedures", {
        get: function () {
            return this._procedures;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProcedureListingComponent.prototype, "anyChanged", {
        get: function () {
            return this._changedProcedures.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProcedureListingComponent.prototype, "changedOnlyTooltip", {
        get: function () {
            return this.anyChanged ? null : NO_PROCS_CHANGED;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProcedureListingComponent.prototype, "anyDeleted", {
        get: function () {
            return this._deletedProcedures.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProcedureListingComponent.prototype, "hideDeletedTooltip", {
        get: function () {
            return this.anyDeleted ? null : NO_PROCS_DELETED;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProcedureListingComponent.prototype, "sortedProcedures", {
        /**
         * Returns active terminal procedures sorted by type and name.
         * @returns {Array<TerminalProcedure>}
         */
        get: function () {
            return this._sortedProcedures;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProcedureListingComponent.prototype, "selectedProcedures", {
        get: function () {
            if (!this.procedureComponents) {
                return [];
            }
            return this.procedureComponents
                .filter(function (c) { return c.selected; })
                .map(function (c) { return c.procedure; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProcedureListingComponent.prototype, "allSelected", {
        get: function () {
            var procedures = this._changedOnly ? this._changedProcedures : this._activeProcedures;
            return this.selectedProcedures.length === procedures.length;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProcedureListingComponent.prototype, "downloadDisabled", {
        get: function () {
            return this.selectedProcedures.length < 1 || this.selectedProcedures.length > MAX_PROC_BATCH_LIMIT;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProcedureListingComponent.prototype, "downloadTooltip", {
        get: function () {
            var selected = this.selectedProcedures;
            if (selected.length < 1) {
                return 'Please select at least one procedure to download.';
            }
            if (selected.length > this.MAX_PROCEDURES) {
                return "Please select no more than " + this.MAX_PROCEDURES + " procedures to download in a single batch.";
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProcedureListingComponent.prototype, "placeholderMessage", {
        get: function () {
            if (this._allProcedures.length === 0) {
                return NO_PROCS_AVAILABLE;
            }
            if (this._changedOnly && this._changedProcedures.length === 0) {
                return NO_PROCS_CHANGED;
            }
            return null;
        },
        enumerable: true,
        configurable: true
    });
    ProcedureListingComponent.prototype._resetSettings = function () {
        this._cycle = TerminalProcedureCycle.Current;
        this._changedOnly = false;
        this._hideDeleted = false;
    };
    ProcedureListingComponent.prototype._updateProcedures = function () {
        this.clearSelection();
        this._procedureSet = this._procedurePack[this._cycle];
        this._allProcedures = this._procedureSet.procedures;
        this._activeProcedures = this._allProcedures.filter(function (p) { return p.changeType !== ChangeType.Deleted; });
        this._changedProcedures = this._allProcedures
            .filter(function (p) { return p.changeType === ChangeType.Added || p.changeType === ChangeType.Changed; });
        this._deletedProcedures = this._allProcedures.filter(function (p) { return p.changeType === ChangeType.Deleted; });
        this._procedures = this._changedOnly
            ? this._changedProcedures
            : (this._hideDeleted ? this._activeProcedures : this._allProcedures);
        this._sortedProcedures = sortBy(this._procedures, [function (p) { return TerminalProcedure.formatProcedureType(p.type); }, 'name']);
        this._effDateFrom = this._procedureSet.effDateFrom;
        this._effDateTo = this._procedureSet.effDateTo;
    };
    ProcedureListingComponent.prototype.clearSelection = function () {
        if (this.procedureComponents) {
            this.procedureComponents.forEach(function (c) {
                if (c.procedure.changeType !== ChangeType.Deleted) {
                    c.selected = false;
                }
            });
        }
    };
    ProcedureListingComponent.prototype.toggleAll = function () {
        var selected = !this.allSelected;
        this.procedureComponents.forEach(function (c) {
            if (c.procedure.changeType !== ChangeType.Deleted) {
                c.selected = selected;
            }
        });
    };
    ProcedureListingComponent.prototype.download = function (format) {
        var selected = this.selectedProcedures;
        if (selected.length < 1) {
            return null;
        }
        if (selected.length > MAX_PROC_BATCH_LIMIT) {
            return null;
        }
        var url = this._airportService.getProcedureBatchUrl(this.selectedProcedures, format);
        window.open(url);
    };
    return ProcedureListingComponent;
}());
export { ProcedureListingComponent };
